import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadPdf } from "@/lib/api";

export function PdfButton({ kind, result, profile, testId, dark }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadPdf(kind, result, profile);
      toast.success("PDF downloaded");
    } catch {
      toast.error("Could not generate the PDF. Please try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button onClick={run} disabled={busy} data-testid={testId}
      className={`inline-flex items-center gap-1.5 self-start rounded-md px-4 py-2.5 text-sm font-semibold shadow-sm transition-colors disabled:opacity-60 ${
        dark ? "bg-[#0F172A] text-white hover:bg-[#1E293B]" : "border border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
      }`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Download PDF
    </button>
  );
}
